// =====================================
//
//   Search Product Controller
//   Author: Gray
//   createtime: 2016 / 08 / 31
//   updatetime: 2016 / 09 / 07
//
// =====================================
window.InifECMobileApp.controller("SearchProductController", ['$scope', '$state', '$timeout', '$stateParams', '$rootScope', 'ProductService', '$WebTitle',
	function($scope, $state, $timeout, $stateParams, $rootScope, ProductService, $WebTitle) {

        // --------------------------------
        // 取得搜尋商品結果
        // --------------------------------
        var getSearchProduct = function() {

            if ($scope.isLoading || $scope.isNoMore || $scope.isEmpty) {
                return
            }

            $scope.isLoading = true;

            ProductService.searchProduct($scope.currentKeyword, $scope.start, $scope.len).then(function (result) {

                if (Array.isArray(result) && result.length > 0) {

                    var _products = formatProducts(result);
                    Array.prototype.push.apply($scope.products, _products);

                    $scope.start += result.length;

                } else if ($scope.products.length > 0) {
                    $scope.isNoMore = true;
                } else if ($scope.products.length == 0) {
                    $scope.isEmpty = true;
                }

                $scope.isLoading = false;

            }, function (error) {
                $scope.isError = true;
                $scope.isLoading = false;
            });
        }

        // --------------------------------
        // [private] 將複合商品資訊補上，以及各個商品的標籤
        // --------------------------------
        var formatProducts = function(products) {

            var _products = [];

            for(var i = 0; i < products.length; i++) {
                var product = products[i];
                product.isComplex = false;
                product.resultName = product.name;
                getProductMinCountPrice(product);

                // 判斷是否為複合商品
                if(product.complexidList && product.complexidList.length > 0) {
                    product.isComplex = true;
                    product.resultName = product.name + ' - ' + product.materialType;
                }

                if(product.isComplex) {
                    product.linkurl = $state.href(window.STATES.COMPLEX_PDT, {complexid: product.complexidList[0] ,productid: product.productid});
                } else {
                    product.linkurl = $state.href(window.STATES.PRODUCT, {productid: product.productid});
                }

                switch(product.label) {
                    case 1:
                        product.labelclass = ' new show-tip ';
                        break;
                    case 2:
                        product.labelclass = ' recommend show-tip ';
                        break;
                    case 4:
                        product.labelclass = ' hot show-tip ';
                        break;
                    case 8:
                        product.labelclass = ' free-shipping show-tip ';
                        break;
                }

                _products.push(product);
            }

            return _products;
        }

        // --------------------------------
        // [private] 取的最低價的個數和單位
        // --------------------------------
        var getProductMinCountPrice = function(product) {
var minKey; // bundler：原本是隱式全域（沒有 var），strict mode 會 ReferenceError

            if(product.priceTable && product.priceTable.rule) {
                var minPrice = -1;

                for(var key in product.priceTable.rule) {
                    var price = product.priceTable.rule[key];

                    if(minPrice < 0 || minPrice > price) {
                        minPrice = price;
                        minKey = key;
                    }
                }

                if(minKey) {
                    product.minPrice = minPrice;

                    for(var i = 0; i < product.specs.length; i++) {
                        var spec = product.specs[i];
                        if(minKey.indexOf(spec.specid) != -1 ) {
                            product.minPrintingUnit = spec.printingUnit;

                            for(var j = 0; j < spec.countList.length; j++) {

                                if(!product.minCount || product.minCount > spec.countList[j]) {
                                    product.minCount = spec.countList[j];
                                }
                            }

                            break;
                        }
                    }
                }
            }
        }

        // --------------------------------
        // 取得商品封面圖
        // --------------------------------
        var getProductCoverImage = function(product) {

            if (!product || !Array.isArray(product.covers) || product.covers.length == 0) {
                return "about:blank";
            }

            return product.covers[0].replace("medium", "small");
        }

        // --------------------------------
        // 叫出搜尋bar
        // --------------------------------
        var openSearchBar = function() {

            $scope.isShowSearchBar = true;

            $timeout(function() {
                $('#search-pdt-input').focus();
            },300);
        }

        // --------------------------------
        // 關閉搜尋bar
        // --------------------------------
        var closeSearchBar = function() {

            $scope.isShowSearchBar = false;
        }

        // --------------------------------
        // 搜尋商品
        // --------------------------------
        var searchProduct = function(event) {

            if(event) {
                event.preventDefault();
            }

            if($scope.form.keyword) {
                $state.go(window.STATES.SEARCH_PDT, {
                    keyword: $scope.form.keyword
                });
            }
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {

            getSearchProduct();
        }

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {

        });

        //==========================
        //  Members
        //==========================
        $scope.form = {
            keyword: ''
        };

        $scope.currentKeyword = $stateParams.keyword;

        $scope.isLoading = false;
        $scope.isEmpty = false;
        $scope.isNoMore = false;
        $scope.isError = false;
        $scope.start = 0;
        $scope.len = 15;
        $scope.products = [];
        $scope.isShowSearchBar = false;

        //==========================
        //  Methods
        //==========================
        $scope.getSearchProduct = getSearchProduct; // 取得搜尋商品結果
        $scope.getProductCoverImage = getProductCoverImage; // 取得商品封面圖
        $scope.openSearchBar = openSearchBar; // 叫出搜尋bar
        $scope.closeSearchBar = closeSearchBar;  // 關閉搜尋bar
        $scope.searchProduct = searchProduct; // 搜尋商品
        
        //==========================
        //  Init
        //==========================
        init();
	}
]);